import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import {
  If,
  ImageComponent,
  VideoPlayerComponent,
  WebinarInfoPanelComponent,
} from '../../../sharedLegacy/components'
import { alterTransparency } from '../../../sharedLegacy/utils'
import { ThankYouMessageComponent, WaitingRoomCountdownComponent } from '..'
import { useWebinarColors } from '../../../sharedLegacy/hooks/useWebinarColors'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import './MediaWaitingRoomScreenComponent.scss'
import './MediaWaitingRoomScreenComponent.mobile.scss'

const renderMedia = (opts, liveData) => {
  const { waitingRoomType, isWebinarOver, isMobileDevice } = opts
  const prefix = isWebinarOver ? 'after' : 'before'

  if (waitingRoomType === 'image') {
    return (
      <ImageComponent
        className="image-cover"
        src={liveData[`${prefix}_webinar_photo_url`]}
      />
    )
  }

  return (
    <VideoPlayerComponent
      object={{
        photo_id: liveData[`${prefix}_webinar_photo_id`],
        token: liveData[`${prefix}_webinar_photo_token`],
      }}
      objectType="photo"
      options={{
        autoPlay: 1,
        mutedAutoPlay: 1,
        ...(isMobileDevice && { unmuteButtonPosition: 'rightTop' }),
        corePeopleDisabled: 0,
        source: 'webinarwaitingroom',
        showTray: 0,
        loop: 1,
        include_actions_p: 0,
      }}
    />
  )
}

const renderInfoPanel = () => (
  <WebinarInfoPanelComponent
    theme="waiting-room"
    style={{ color: '#FFFFFF' }}
  />
)

const getDecorationLineStyle = (isMobileDevice, accentColor) => {
  if (!isMobileDevice) {
    return { backgroundColor: accentColor }
  }

  return {
    background: `linear-gradient(-90deg, ${alterTransparency(
      accentColor,
      0
    )}, ${alterTransparency(accentColor, 1)})`,
  }
}

const MediaWaitingRoomScreenComponent = (props) => {
  const {
    webinarTimeEpoch,
    isWebinarTimeInThePast,
    onLiveCountdownZero,
    hasBeenBroadcasting,
    countdownEnabled,
    waitingRoomType,
    isWebinarOver,
    isMobileDevice,
  } = props

  const webinarColors = useWebinarColors()
  const accentColor = webinarColors.accent.color

  const { data: liveData } = useLiveDataQuery()

  if (!liveData) {
    return null
  }

  const classes = classnames(
    `media-waiting-room-screen-component ${waitingRoomType}-room`,
    {
      'webinar-is-over': isWebinarOver,
    }
  )

  return (
    <div className={classes}>
      <div className="media">{renderMedia(props, liveData)}</div>
      <div className="footer">
        <If condition={countdownEnabled && !isWebinarOver}>
          <WaitingRoomCountdownComponent
            webinarTimeEpoch={webinarTimeEpoch}
            isWebinarTimeInThePast={isWebinarTimeInThePast}
            isHolding={hasBeenBroadcasting}
            onLiveCountdownZero={onLiveCountdownZero}
          />
        </If>
        <If condition={!isWebinarOver || !liveData.after_webinar_link}>
          <div
            className="decoration-line"
            style={getDecorationLineStyle(isMobileDevice, accentColor)}
          />
        </If>
        {isWebinarOver ? <ThankYouMessageComponent /> : renderInfoPanel()}
      </div>
    </div>
  )
}

MediaWaitingRoomScreenComponent.propTypes = {
  waitingRoomType: PropTypes.oneOf(['image', 'video']),
  webinarTimeEpoch: PropTypes.number,
  isWebinarTimeInThePast: PropTypes.bool,
  hasBeenBroadcasting: PropTypes.bool,
  countdownEnabled: PropTypes.bool,
  onLiveCountdownZero: PropTypes.func,
  isWebinarOver: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
}

export default MediaWaitingRoomScreenComponent
